import React, { useMemo } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types'
import ProfilePersonalInformationComponent from './ProfilePersonalInformation/ProfilePersonalInformation.container';
import SecurityPasswordComponent from './SecurityPassword/SecurityPassword.container';
import { PaymentPageContainer as PaymentPageContainerComponent } from '../../../../adapters/routeAdapters';
import classNames from 'classnames';
import { Link, withRouter } from '../../RouterCompatibility';

const ProfilePage = ({ location, t }) => {
    const pathname = (location && location.pathname) || (typeof window !== 'undefined' ? window.location.pathname : '/');
    const searchParams = new URLSearchParams(location?.search || '');
    const currentTab = searchParams.get('tab') || 'personalInfo';

    const getClassTabItem = useMemo(() => (key) => {
        return classNames({
            'active': currentTab === key
        });
    }, [currentTab]);

    const getClassTabPane = useMemo(() => (key) => {
        return classNames({
            'tab-pane': true,
            'active': currentTab === key
        });
    }, [currentTab]);

    const staticNames = t?.profilePage || {};
    const staticNameUsers = t?.paymentPage || {};
    const staticNameSecurity = t?.securityPage || {};

    return (
        <React.Fragment>
            <div className="page-heading mobile-heading-fixed">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content user">
                <div className="ibox">
                    <div className="ibox-content">
                        <div className="profile_tab-wrap">
                            <ul className="nav nav-tabs" id="profileTab">
                                <li className={getClassTabItem('personalInfo')}>
                                    <Link to={`${pathname}?tab=personalInfo`}>{staticNames.personalInformation?.title}</Link>
                                </li>
                                <li className={getClassTabItem('security')}>
                                    <Link to={`${pathname}?tab=security`}>{staticNameSecurity.changePassword?.title}</Link>
                                </li>
                                <li className={getClassTabItem('payments')}>
                                    <Link to={`${pathname}?tab=payments`}>{staticNameUsers.details?.title}</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="tab-content">
                            <div className={getClassTabPane('personalInfo')}>
                                <ProfilePersonalInformationComponent />
                            </div>
                            <div className={getClassTabPane('security')}>
                                <SecurityPasswordComponent />
                            </div>
                            <div className={getClassTabPane('payments')}>
                                <PaymentPageContainerComponent inProfilePage={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

ProfilePage.propTypes = {
    location: PropTypes.object,
    t: PropTypes.object
};

export default withTranslation(withRouter(ProfilePage));
